import { Stack, Typography } from "@mui/material"

import type { EntryChange } from "types/changelog.types"

import ChangeTag from "./ChangeTag"

interface ChangeProps {
  change: EntryChange
  variant?: "compact" | "full"
}

const Change = ({ change, variant = "full" }: ChangeProps) => {
  const isCompact = variant === "compact"

  return (
    <Stack mb={2} spacing={1} px={isCompact ? 2 : 0}>
      <Stack
        direction={isCompact ? "row" : "column"}
        alignItems={isCompact ? "center" : "flex-start"}
        spacing={1}
      >
        <ChangeTag type={change.type} />
        <Typography variant="h5">{change.title}</Typography>
      </Stack>
      <Typography variant="body2" color="text.secondary">
        {change.description}
      </Typography>
    </Stack>
  )
}

export default Change
